export const LOAD_COMMISSIONS_STARTED = "LOAD_COMMISSIONS_STARTED";
export const LOAD_COMMISSIONS_SUCCESS = "LOAD_COMMISSIONS_SUCCESS";
export const COMMISSIONS_UPDATED = "COMMISSIONS_UPDATED";
export const COMMISSION_COMPUTED = "COMMISSION_COMPUTED";
export const COMMISSION_ADDED = "COMMISSION_ADDED";
export const COMPUTED_RESET = "COMPUTED_RESET";
export const SAVE_COMMISSIONS_STARTED = "SAVE_COMMISSIONS_STARTED";
export const SAVE_COMMISSIONS_FINISHED = "SAVE_COMMISSIONS_FINISHED";
export const COMMISSION_DELETED = "COMMISSION_DELETED";
export const LOAD_CALCULATION_METHODS_SUCCESS = "LOAD_CALCULATION_METHODS_SUCCESS";
